import { render, staticRenderFns } from "./WhatsAppMessager.vue?vue&type=template&id=f708a2d0"
import script from "./WhatsAppMessager.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports